import { Chain } from "@web3-onboard/common/dist/types";

export const L1_CHAIN: Chain = process.env.NODE_ENV === 'production'
    ? { id: '0x1', token: 'ETH', label: 'Ethereum Mainnet', rpcUrl: process.env.VUE_APP_RPC_URL_ETH || '' }
    : { id: '0x5', token: 'ETH', label: 'Goerli', rpcUrl: process.env.VUE_APP_RPC_URL_GOERLI || '' };